module.exports = __webpack_public_path__ + "img/scanner.6da47735.jpg";